/* Gift FAQs: one answer open at a time, as the name= group in the markup, but the open answer closes while the new
   one opens instead of snapping shut (Arsalan 2026-10-26). Without this script the native group still works. */
if (!customElements.get('c4u-gift-faq')) {
  customElements.define('c4u-gift-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.items = [...this.querySelectorAll('.c4ugfaq__item')];
      this.items.forEach((item) => item.removeAttribute('name'));
      this.addEventListener('click', (event) => {
        const question = event.target.closest('.c4ugfaq__question');
        if (!question || !this.contains(question)) return;
        event.preventDefault();
        const item = question.parentElement;
        const open = !item.open || item.classList.contains('is-closing');
        if (open) {
          this.items.forEach((other) => {
            if (other !== item && other.open && !other.classList.contains('is-closing')) this.setOpen(other, false);
          });
        }
        this.setOpen(item, open);
      });
    }

    setOpen(item, open) {
      const answer = item.querySelector('.c4ugfaq__answer');
      const from = item.getBoundingClientRect().height;
      // A closed answer at rest still computes opacity 1, so a fresh open fades in from 0.
      const fade = item.motion ? getComputedStyle(answer).opacity : (open ? 0 : 1);
      (item.motion || []).forEach((animation) => animation.cancel());
      item.classList.toggle('is-closing', !open);
      if (open) item.open = true;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return this.settle(item);
      const edge = getComputedStyle(item);
      const to = open
        ? item.getBoundingClientRect().height
        : item.querySelector('.c4ugfaq__question').getBoundingClientRect().height + parseFloat(edge.borderTopWidth) + parseFloat(edge.borderBottomWidth);
      const timing = { duration: 400, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' };
      item.classList.add('is-moving');
      item.motion = [
        item.animate({ height: [`${from}px`, `${to}px`] }, timing),
        answer.animate({ opacity: [fade, open ? 1 : 0] }, timing),
      ];
      // A click mid-way cancels these, which rejects; the newer animation settles the item instead.
      item.motion[0].finished.then(() => this.settle(item), () => {});
    }

    settle(item) {
      item.classList.remove('is-moving');
      if (item.classList.contains('is-closing')) {
        item.open = false;
        item.classList.remove('is-closing');
      }
      (item.motion || []).forEach((animation) => animation.cancel());
      item.motion = null;
    }
  });
}
